"use client";

const PrivacySettingsLink = ({ className }: { className: string }) => (
  <a
    href="#"
    onClick={(e) => {
      e.preventDefault();
      __ucCmp.showSecondLayer();
    }}
    className={className}
  >
    Privacy Settings
  </a>
);

export { PrivacySettingsLink };
